document.addEventListener('DOMContentLoaded', () => {
    initForms('contact-form');
});

function initForms(formId) {
    const form = document.getElementById(formId);
    if (!form) return;

    const DEV_KEY = '1x00000000000000000000AA';
    const PROD_KEY = '0x4AAAAAACLwpnv91XwUIREf';

    const isDev = location.hostname === '127.0.0.1';
    const turnstileWidget = document.getElementById('turnstile-widget');

    if (window.turnstile && turnstileWidget) {
        turnstile.render(turnstileWidget, {
            sitekey: isDev ? DEV_KEY : PROD_KEY
        });
    }

    const submitButton = form.querySelector('button');
    const originalButtonText = submitButton.innerHTML;

    const successMessage = document.getElementById('form-success');
    const errorMessage = document.getElementById('form-error');
    const errorText = errorMessage.querySelector('p');

    form.addEventListener('submit', async (e) => {
        e.preventDefault();

        const formData = new FormData(form);

        successMessage.classList.add('hidden');
        errorMessage.classList.add('hidden');

        submitButton.disabled = true;
        submitButton.innerHTML = 'Sending...';

        try {
            const response = await fetch('/api/forms', {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || 'Form submission failed');
            }

            successMessage.classList.remove('hidden');
            successMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
            form.reset();
        } catch (error) {
            console.error('Form Submission Error:', error);
            errorText.textContent = error.message || 'An unexpected error occurred. Please try again later.';
            errorMessage.classList.remove('hidden');
            errorMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } finally {
            submitButton.innerHTML = originalButtonText;
            submitButton.disabled = false;
        }
    });
}